// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import excerptLimit from "./excerptLimit";
import { linkToArticle } from "./linktToArticle";
import menuOpen from "./menuOpen";
import menuOpenSubmenu from "./menuOpenSubmenu";
import menuScroll from "./menuScroll";
import upArrow from "./upArrow";
// import infiniteScroll from "./infiniteScroll";


// Call the menu and infinite scroll functions
excerptLimit();
menuOpen();
menuScroll();
menuOpenSubmenu();
upArrow();
linkToArticle();
// infiniteScroll();